import {Directive, ElementRef, HostListener, Input} from "@angular/core";
import {forEach, get, mapValues, set, values} from "lodash-es";
import ClickEvent = JQuery.ClickEvent;

@Directive({
  selector: '[prefab-widget-id]',
  standalone: true,
  exportAs: 'prefabWidgetId',
})
export class PrefabWidgetIdDirective {
  @Input('prefab-widget-id') prefabWidgetId: string;

  private componentInstance: any;
  private $el: JQuery<HTMLElement>;
  private externalEventRegistered: boolean = false;
  private prefabScope: any;
  private page: any;


  _prefabActiveWidgetClick($event: ClickEvent) {
    let widgetId = this.$el.attr('prefab-widget-id');
    if ($event && $event.originalEvent && !get($event.originalEvent, '_prefab_widget_stop_propgation')) {
      set($event.originalEvent, '__skipExternalEvent', true);
      set($event.originalEvent, '_prefab_widget_stop_propgation', true);
      let $prefab = this.$el.parent().closest('section.app-prefab');
      $prefab.find('.active-prefab-widget').removeClass('active-prefab-widget');
      let prefabScope: any = get($prefab[0], 'widget');
      if (!prefabScope) {
        return;
      }
      this.prefabScope = prefabScope;
      prefabScope.resetWidgetProps && prefabScope.resetWidgetProps();
      let oldShowProperties = mapValues(prefabScope.widgetProps, 'show');
      prefabScope.resetWidgetProps = function() {
        forEach(prefabScope.widgetProps, (v: any, key: string) => {
          prefabScope.widgetProps[key].show =  oldShowProperties[key];
        });
        prefabScope.resetWidgetProps = null;
      };
      forEach(values(prefabScope.widgetProps), (prop) => {
        prop.show = ((prefabScope.prefabName + '.' + prop.showAt === widgetId) && !prop.isHidden);
      });
      this.$el.addClass('active-prefab-widget');

      // register for click event on page
      if (!this.externalEventRegistered) {
        this.$el.attr('tabindex', 100001);
        this.$el.on('keydown', this.listener.bind(this));
        this.page = this.$el.closest('.app-page');
        if (!this.page.length) {
          this.page = this.$el.closest('.wm-prefab-page');
        }

        prefabScope.destroy.subscribe(this.globalClickListener);

        this.page.click(this.globalClickListener.bind(this));
        this.externalEventRegistered = true;
      }
    }
  }

  listener($event: any) {
    $event.stopPropagation();
    if ($event.charCode === 0) {
      this.globalClickListener($event);
    }
  }

  globalClickListener(event: any) {
    if (!(event && event.originalEvent && event.originalEvent.__skipExternalEvent)) {
      this.$el.removeClass('active-prefab-widget');
      this.externalEventRegistered = false;
      this.page.off('click', this.globalClickListener);
      this.$el.off('keydown', this.listener);
      this.$el.removeAttr('keydown');
    }
    if (!(event && event.originalEvent && event.originalEvent._prefab_widget_stop_propgation)) {
      this.prefabScope.resetWidgetProps && this.prefabScope.resetWidgetProps();
    }
  };

  constructor(el: ElementRef) {
    this.$el = $(el.nativeElement);
    this.componentInstance = el.nativeElement.widget;

    this.$el.on('click', this._prefabActiveWidgetClick.bind(this));
  }
}
